export enum DataApiTypes {
  mandatory = 'mandatory',
  optional = 'optional',
  forbidden = 'forbidden',
}
